"use strict";

var _interopRequireDefault = require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/web.dom.iterable");
var _interopRequireWildcard2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
var _router = require("@/router");
var _layout = _interopRequireDefault(require("@/layout"));
var _store = _interopRequireDefault(require("@/store"));
// import { getMenu } from '@/utils/auth'

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function getComponent(item_id) {
  switch (item_id) {
    case 'Apply/index':
      return function () {
        return Promise.resolve().then(function () {
          return (0, _interopRequireWildcard2.default)(require('@/views/Apply'));
        });
      };
    case 'User/index':
      return function () {
        return Promise.resolve().then(function () {
          return (0, _interopRequireWildcard2.default)(require('@/views/User'));
        });
      };
    case 'Role/index':
      return function () {
        return Promise.resolve().then(function () {
          return (0, _interopRequireWildcard2.default)(require('@/views/Role'));
        });
      };
    case 'Branch/index':
      return function () {
        return Promise.resolve().then(function () {
          return (0, _interopRequireWildcard2.default)(require('@/views/Branch'));
        });
      };
    case 'Log/index':
      return function () {
        return Promise.resolve().then(function () {
          return (0, _interopRequireWildcard2.default)(require('@/views/Common/Log'));
        });
      };
    case 'Login/index':
      return function () {
        return Promise.resolve().then(function () {
          return (0, _interopRequireWildcard2.default)(require('@/views/Common/LoginLog'));
        });
      };
    case 'menuList/index':
      return function () {
        return Promise.resolve().then(function () {
          return (0, _interopRequireWildcard2.default)(require('@/views/Menu/index'));
        });
      };
    default:
      console.warn('没有导入相应的页面:', '@/views/' + item_id);
      return function () {
        return Promise.resolve().then(function () {
          return (0, _interopRequireWildcard2.default)(require('@/views/error-page/404'));
        });
      };
  }
}
function turnMenuToRoutes(menu) {
  menu.forEach(function (item) {
    item.name = item.component_name;
    item.meta = {
      title: item.menu_name,
      icon: item.icon,
      affix: false,
      noCache: !Number(item.no_cache)
    };
    item.path = !item.url.includes('index') ? '/' + item.id : item.url;
    if (item.children && item.children[0] && item.children[0].action) {
      item.meta.authList = item.children.map(function (child) {
        return child.url;
      });
      delete item.children;
    }
    if (item.children && item.children.length > 0) {
      item.component = _layout.default;
      item.redirect = item.children[0].url;
      item.children = turnMenuToRoutes(item.children);
    } else {
      item.component = getComponent(item.path);
    }
  });
  return menu;
}
var state = {
  routes: [],
  addRoutes: []
};
var mutations = {
  SET_ROUTES: function SET_ROUTES(state, routes) {
    state.addRoutes = routes;
    state.routes = _router.constantRoutes.concat(routes);
  }
};
var actions = {
  generateRoutes: function generateRoutes(_ref) {
    var commit = _ref.commit;
    return new Promise(function (resolve) {
      var accessedRoutes = [];
      var menu = _store.default.state.user.menu;
      if (menu !== '') {
        accessedRoutes = turnMenuToRoutes(menu);
      }
      commit('SET_ROUTES', accessedRoutes);
      resolve(accessedRoutes);
    });
  }
};
var _default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};
exports.default = _default;